export default __webpack_public_path__ + "static/media/user_guide5.23a5aedc.png";